import React from "react";
import CIcon from "@coreui/icons-react";
import { cilBalanceScale, cilBug, cilCasino, cilLibrary } from "@coreui/icons";
import { CNavGroup, CNavItem, CNavTitle } from "@coreui/react-pro";
//will set
const _nav = [
  {
    component: CNavTitle,
    name: "Belgeler",
    role: "everyone",
    show: "true",
  },
  {
    component: CNavItem,
    name: "ÖDR Değerlendirme Şablonu",
    to: "/appeal-template",
    icon: (
      <CIcon
        icon={cilLibrary}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "organisation",
    show: "true",
  },
  {
    component: CNavItem,
    name: "ÖDR Değerlendirme Şablonu",
    to: "/appeal-template",
    icon: (
      <CIcon
        icon={cilLibrary}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "teamLeader",
    show: "true",
  },
  {
    component: CNavItem,
    name: "ÖDR Değerlendirme Şablonu",
    to: "/appeal-template",
    icon: (
      <CIcon
        icon={cilLibrary}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "evaluator",
    show: "true",
  },
  /* {
    component: CNavItem,
    name: "ÖDR Değerlendirme Şablonu",
    to: "/appeal-template",
    icon: (
      <CIcon
        icon={cilLibrary}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "evaluator",
    show: "true",
  }, */
  /* {
    component: CNavItem,
    name: "ÖDR Değerlendirme Şablonu",
    to: "/appeal-template",
    icon: (
      <CIcon
        icon={cilLibrary}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "teamLeader",
    show: "true",
  }, */
  {
    component: CNavItem,
    name: "Başvurular",
    to: "/application-list",
    icon: (
      <CIcon
        icon={cilBalanceScale}
        size="sm"
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "organisation",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Başvurular",
    to: "/application-list",
    icon: (
      <CIcon
        icon={cilBalanceScale}
        size="sm"
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "admin",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Öz D. Raporu",
    to: "/self-report",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "organisation",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Öz D. Raporu",
    to: "/self-report",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "admin",
    show: "true",
  },
  {
    component: CNavItem,
    name: "30 Gün Yanıtı",
    to: "/month-response",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        size="sm"
        customClassName="nav-icon"
      />
    ),
    role: "organisation",
    show: "true",
  },
  {
    component: CNavItem,
    name: "30 Gün Yanıtı",
    to: "/month-response",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        size="sm"
        customClassName="nav-icon"
      />
    ),
    role: "admin",
    show: "true",
  },
  {
    component: CNavItem,
    name: "SAK'tan Geri Dönen Programlar",
    to: "/application-loop",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        size="sm"
        customClassName="nav-icon"
      />
    ),
    role: "organisation",
    show: "true",
  },
  {
    component: CNavItem,
    name: "SAK'tan Geri Dönen Programlar",
    to: "/application-loop",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        size="sm"
        customClassName="nav-icon"
      />
    ),
    role: "admin",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Etik Sözleşme Şablonu",
    to: "/ethics-deal",
    icon: (
      <CIcon
        icon={cilLibrary}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "organisation",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Etik Sözleşme Şablonu",
    to: "/ethics-template",
    icon: (
      <CIcon
        icon={cilLibrary}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "teamLeader",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Etik Sözleşme Şablonu",
    to: "/ethics-template",
    icon: (
      <CIcon
        icon={cilLibrary}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "evaluator",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Etik Sözleşme Şablonu",
    to: "/ethics-template",
    icon: (
      <CIcon
        icon={cilLibrary}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "student",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Etik Sözleşme Şablonu",
    to: "/ethics-template",
    icon: (
      <CIcon
        icon={cilLibrary}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "watcher",
    show: "true",
  },

  {
    component: CNavItem,
    name: "ÖDR Ön İnceleme",
    to: "/self-report-preview",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "teamLeader",
    show: "true",
  },
  {
    component: CNavItem,
    name: "ÖDR Ön İnceleme",
    to: "/self-report-preview",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "student",
    show: "true",
  },
  {
    component: CNavItem,
    name: "ÖDR Ön İnceleme",
    to: "/self-report-preview",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "watcher",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Şekilsel İnceleme",
    to: "/formal-review",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "teamLeader",
    show: "true",
  },
  {
    component: CNavItem,
    name: "SAK'tan Geri Dönen Programlar",
    to: "/application-loop",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        size="sm"
        customClassName="nav-icon"
      />
    ),
    role: "teamLeader",
    show: "true",
  },
  {
    component: CNavItem,
    name: "ÖDR Ön İnceleme",
    to: "/self-report-preview",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "admin",
    show: "true",
  },
  {
    component: CNavItem,
    name: "ÖDR Ön İnceleme",
    to: "/self-report-preview",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "evaluator",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Değerlendirme",
    to: "/evaluation",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "evaluator",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Değerlendirme",
    to: "/evaluation",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "admin",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Değerlendirici Raporları",
    to: "/evaluator-report",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "teamLeader",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Değerlendirici Raporları",
    to: "/evaluator-report",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "admin",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Değerlendirici Raporları",
    to: "/evaluator-report",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "student",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Değerlendirici Raporları",
    to: "/evaluator-report",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "watcher",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Taslak Rapor",
    to: "/draft-report",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "teamLeader",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Taslak Rapor",
    to: "/draft-report",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "admin",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Program Raporları",
    to: "/consistency",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "consistency",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Program Raporları",
    to: "/consistency",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "admin",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Program Değerlendirme Raporları",
    to: "/editor",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "editor",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Program Değerlendirme Raporları",
    to: "/editor",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "admin",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Yazım Kontrol",
    to: "/spelling-control",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "spelling",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Yazım Kontrol",
    to: "/spelling-control",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "admin",
    show: "true",
  },

  /*  {
    component: CNavTitle,
    name: "Şablonlar",
    role: "everyone",
    show: "true",
  },
  {
    component: CNavItem,
    name: "ÖDR Şablonu",
    to: "/appeal-template",
    icon: (
      <CIcon
        icon={cilLibrary}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "everyone",
    show: "true",
  }, */

  {
    component: CNavTitle,
    name: "Yardım",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Denemeler",
    to: "/try",
    icon: (
      <CIcon
        icon={cilBug}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
  },

  /*
    {
      component: CNavTitle,
      name: 'Dashboard Group',
      to: '/dashboard',
      icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
      badge: {
        color: 'danger',
        text: 'HEY!',
      },
    },
    {
      component: CNavItem,
      name: 'Dashboard',
      to: '/dashboard',
      icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
      badge: {
        color: 'danger',
        text: 'HEY!',
      },
    },
    {
      component: CNavGroup,
      name: 'Başvuru Formu',
      to: '/application_form',
      icon: <CIcon icon={cilFactory} customClassName="nav-icon" />,
      badge: {
        color: 'info-gradient',
        text: 'HEYO!',
      },
      items: [
        {
          component: CNavItem,
          name: 'Sub dash',
          to: '/dashboard',
          icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
          badge: {
            color: 'danger',
            text: 'SUB!',
          },
        },
      ]
    },
  */
];

export default _nav;
